<template>
  <button @click="$emit('toggle')" class="toggleWidget">
    {{ value }}
    <Icon :icon="icon" />
  </button>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import Icon from '@/components/Icon'

@Component({
  components: {
    Icon,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
  },
})
export default class ToggleWidget extends Vue {
}
</script>

<style lang="scss">
.toggleWidget {
  background-color: transparent;
  text-transform: uppercase;
  position: absolute;
  font-size: 13px;
  right: 20px;
  top: 18px;
  border: 0;
  padding-right: 20px;

  .figure {
    font-size: 11px;
    position: absolute;
    right: 0;
    top: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/googleMap/buttons/ToggleWidget.vue